"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "./ui";

const ITEMS = [
  { href: "/admin/viral-remix", label: "Viral Analyze", icon: "🔥" },
  { href: "/admin/workflow", label: "Workflow", icon: "🛠️" },
  { href: "/admin/templates", label: "Templates", icon: "🧩" },
  { href: "/admin/products", label: "Product Twins", icon: "📦" },
  { href: "/admin/avatars", label: "Avatars", icon: "🧍" },
  { href: "/admin/voices", label: "Voices", icon: "🎙️" },
  { href: "/admin/users", label: "Users", icon: "👥" },
  { href: "/admin/token-pricing", label: "Token pricing", icon: "🪙" },
  { href: "/admin/jobs", label: "Job log", icon: "📋" },
  { href: "/admin/audit", label: "Audit", icon: "🔐" },
];

export function AdminNav() {
  const pathname = usePathname();
  return (
    <nav className="flex gap-1 overflow-x-auto px-4 pb-3 lg:flex-col lg:overflow-visible lg:pb-0">
      {ITEMS.map((it) => (
        <Link
          key={it.href}
          href={it.href}
          className={cn(
            "flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm whitespace-nowrap transition",
            pathname.startsWith(it.href)
              ? "bg-white/10 font-medium text-foreground"
              : "text-muted hover:bg-white/5 hover:text-foreground",
          )}
        >
          <span>{it.icon}</span>
          {it.label}
        </Link>
      ))}
    </nav>
  );
}
